/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: e86a911c (Thu May 21 20:23:17 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface FavoriteParam
 */
export interface FavoriteParam {
  /**
   * The `assetKey` is the unique identifier for a content asset.
   * @type number
   * @memberof FavoriteParam
   */
  assetKey: number
  /**
   * Boolean to mark if the item is a favorite or not
   * @type boolean
   * @memberof FavoriteParam
   */
  isFavorited?: boolean
}

export function FavoriteParamFromJSON(json: any): FavoriteParam {
  return FavoriteParamFromJSONTyped(json, false)
}

export function FavoriteParamFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FavoriteParam {
  if (json === undefined || json === null) {
    return json
  }
  return {
    assetKey: json['assetKey'],
    isFavorited: !exists(json, 'isFavorited') ? undefined : json['isFavorited'],
  }
}

export function FavoriteParamToJSON(value?: FavoriteParam | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    assetKey: value.assetKey,
    isFavorited: value.isFavorited,
  }
}
